import { useEffect } from 'react';

/**
 * Sets `document.title` while the calling component is mounted and restores the
 * previous title on unmount.
 *
 * Pass a falsy value to leave the current title untouched (useful while the data
 * needed to build the title is still loading).
 *
 * Only pass non-PHI values (e.g. program/workflow names) — never patient data.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) {
      return;
    }
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
